<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'

const { t } = useI18n()

const open = ref<number | null>(null)
const questions = [1, 2, 3, 4] as const

function toggle(index: number): void {
  open.value = open.value === index ? null : index
}
</script>

<template>
  <section class="bg-white py-24" aria-labelledby="about-faq-title">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <p class="text-emerald-600 font-semibold text-sm uppercase tracking-widest">{{ t('about.faq.eyebrow') }}</p>
        <h2 id="about-faq-title" class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('about.faq.title') }}
        </h2>
      </div>

      <div class="space-y-3">
        <div v-for="n in questions" :key="n" class="border border-slate-200 rounded-xl overflow-hidden">
          <button
            type="button"
            class="w-full text-left px-6 py-4 flex items-center justify-between gap-4 hover:bg-slate-50 transition-colors"
            :aria-expanded="open === n"
            :aria-controls="`about-faq-answer-${n}`"
            @click="toggle(n)"
          >
            <span class="font-semibold text-slate-900">{{ t(`about.faq.q${n}`) }}</span>
            <span class="shrink-0 text-slate-400 motion-safe:transition-transform motion-safe:duration-200" :class="open === n ? 'rotate-180' : ''">
              <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
              </svg>
            </span>
          </button>
          <div v-if="open === n" :id="`about-faq-answer-${n}`" class="px-6 pb-5 text-slate-600 leading-relaxed">
            {{ t(`about.faq.a${n}`) }}
          </div>
        </div>
      </div>

      <p class="mt-8 text-center text-sm">
        <RouterLink to="/docs" class="font-semibold text-emerald-600 hover:text-emerald-500 transition-colors">
          {{ t('about.faq.more_docs') }}
        </RouterLink>
      </p>
    </div>
  </section>
</template>
